import { render, staticRenderFns } from "./collapseGroups.vue?vue&type=template&id=44fd78b4&"
import script from "./collapseGroups.vue?vue&type=script&lang=js&"
export * from "./collapseGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports